<template>
  <div id="ClaimsReturnsSearchResults" class="container">
    <b-row class="mx-0">
      <b-col lg="3" sm="12" class="claimsLeftSidebar">
        <ReverseLogisticsMenu />
        <br>
        <ClaimsOrdersSearch />
      </b-col>
      <b-col lg="9" sm="12" class="">
        <b-row id="searchHeader">
          <h1>Search Results for {{ searchKeyword }}</h1> <!-- TODO Translation -->
        </b-row>
        <b-row id="returns">
          <h3>Returns</h3> <!-- Translation -->
        </b-row>
        <b-row>
          <b-table
            hover
            striped
            :items="returnsData"
            :fields="returnsDataColumns"
            stacked="md"
            :no-provider-filtering="true"
            show-empty
            :no-local-sorting="false"
            class="blue"
          >
            <template slot="CustomerReferenceNumber" slot-scope="row">
              <router-link 
                v-if="row.item.ReturnStatus === 'OPEN' && row.item.Source === 'NotSet'"
                :to="`/claimsAndReturns/createReturn?returnId=${row.item.Id}`"
              >
                {{ row.item.CustomerReferenceNumber }}
              </router-link>
              <router-link 
                v-else 
                :to="`/claimsAndReturns/return/${row.item.Id}?accountId=${row.item.AccountId}&salesOrg=${row.item.SalesOrganization}&returnSource=${row.item.Source}`"
              >
                {{ row.item.CustomerReferenceNumber }}
              </router-link>
            </template>
            <template slot="DateCreated" slot-scope="row">
              <date-time :date-string="row.item.DateCreated" />
            </template>
            <template slot="ReturnStatus" slot-scope="row">
              {{ getContentItem(row.item.ReturnStatus) }}
            </template>
          </b-table>
        </b-row>
        <hr>
        <b-row id="claims">
          <h3>Claims</h3> <!-- Translantion -->
        </b-row>
        <b-row>
          <b-table
            hover
            striped
            :items="claimsData"
            :fields="claimsDataColumns"
            stacked="md"
            :no-provider-filtering="true"
            show-empty
            :no-local-sorting="false"
            class="blue"
          >
            <template slot="CustomerReferenceNumber" slot-scope="row">
              <router-link :to="'/claimsAndReturns/claimDetails?claimNumber='+row.item.ClaimNumber">
                {{ row.item.CustomerReferenceNumber }}
              </router-link>
            </template>
            <template slot="ClaimEnteredDate" slot-scope="row">
              <date-time :date-string="row.item.ClaimEnteredDate" />
            </template>
          </b-table>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import ClaimsOrdersSearch from "@/components/SubMenus/ClaimsOrdersSearch"
  import ReverseLogisticsMenu from "@/components/SubMenus/ReverseLogisticsMenu"
  import { ClaimsService } from "@/services/ClaimsService"
  import { ReturnsService } from "@/services/ReturnsService"
  import DateTime from "@/components/Elements/DateTime"

  export default {
    components: {
      ClaimsOrdersSearch,
      ReverseLogisticsMenu,
      DateTime
    },
    props: {
      referenceNumber: {
        type: String,
        default: ""
      },
      partNumber: {
        type: String,
        default: ""
      },
      accountCode: {
        type: String,
        default: ""
      }
    },
    data: () => ({
      claimsOrdersSearchBoxIdentifier: "Claims",
      returnsDataColumns: [
        { key: "CustomerReferenceNumber", label: "Dealer Return Reference", sortable: true },
        { key: "ReturnAuthorizationCode", label: "Return Number", sortable: true },
        { key: "DateCreated", label: "Date Created", sortable: true },
        { key: "ReturnStatus", label: "Status", sortable: true }
      ],
      returnsData: [],
      claimsDataColumns: [
        { key: "CustomerReferenceNumber", label: "Dealer Claims Reference", sortable: true },
        { key: "ClaimNumber", label: "Claim Number", sortable: true },
        { key: "ClaimEnteredDate", label: "Date Created", sortable: true },
        { key: "ClaimStatus", label: "Status", sortable: true }
      ],
      claimsData: []
    }),
    computed: {
      ...mapGetters(["user", "getContentItem"]),
      searchKeyword () {
        let word = (this.referenceNumber != "")
          ? this.referenceNumber
          : this.partNumber
        return "\"" + word + "\""
      }
    },
    mounted () {
      this.doSearch()
    },
    methods: {
      doSearch () {
        this.claimsData = []
        this.returnsData = []
        ClaimsService.SearchClaims(this.accountCode, this.user.UserId, this.referenceNumber, this.partNumber).then(claimHeaders => {
          if (null != claimHeaders.data) {
            this.claimsData = claimHeaders.data
          }
        })
        ReturnsService.SearchReturns(this.accountCode, this.user.UserId, this.referenceNumber, this.partNumber).then(returnHeaders => {
          if (null != returnHeaders.data) {
            this.returnsData = returnHeaders.data
          }
        })
      }
    },
  }
</script>
